import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/perda";

export const Route = createFileRoute("/_authenticated/perda")({
  head: () => ({
    meta: [
      { title: "Perda / estrago — Milky Moo Palmares" },
      { name: "description", content: "Registre perdas e itens estragados retirados do estoque." },
      { property: "og:title", content: "Perda / estrago — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Registre perdas e itens estragados retirados do estoque.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
